import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    if (title) document.title = title;
    if (description !== undefined && description !== null) {
      let el = document.querySelector('meta[name="description"]');
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", "description");
        document.head.appendChild(el);
      }
      el.setAttribute("content", description || "");
    }
  }, [title, description]);
}
